import { Box, Flex, Heading, Icon, Text } from '@chakra-ui/react';

import { ContactMessageEntry } from '../../../../../../services/marketplace/generated/kubb/models/ContactMessageEntry';
import { relativeFormat } from '../../../../../../utils/dates';
import { formatMoney } from '../../../../../../utils/helpers';
import ConversationDoorway from '../conversation/ConversationDoorway';
import { INACTIVE_VARIANTS, OfferStatusBadges } from './OfferStatusBadges';
import { InactiveCardView } from './utils';

type InactiveOfferCardProps = {
  card: InactiveCardView;
  showConversationEntry: boolean;
  thread?: ContactMessageEntry[];
  onOpenConversation: () => void;
};

const InactiveOfferCard = ({
  card,
  showConversationEntry,
  thread,
  onOpenConversation,
}: InactiveOfferCardProps) => {
  const { dealerLabel, amount, driverCounterAmount, inactiveState, inactiveAt } = card;
  const { icon: stripIcon, strip } = INACTIVE_VARIANTS[inactiveState];
  const stripCopy = strip(driverCounterAmount);

  return (
    <Box
      position="relative"
      overflow="hidden"
      borderWidth="1px"
      borderColor="gainsboro"
      borderRadius="11px"
      bg="white"
      px={{ base: '18px', md: '24px' }}
      py={{ base: '16px', md: '20px' }}
    >
      <Box position="absolute" insetStart={0} top={0} bottom={0} w="3px" bg="offerInactiveAccent" />

      <Flex wrap="wrap" gap="8px" mb="10px" align="center">
        <Text
          as="span"
          fontFamily="heading"
          fontSize={{ base: '13px', md: '14px' }}
          fontWeight="700"
          letterSpacing="0.04em"
          textTransform="uppercase"
          color="grayMedium"
          noOfLines={1}
        >
          Offer {dealerLabel}
        </Text>
        <OfferStatusBadges card={card} />
        <Text
          as="span"
          fontSize="10.5px"
          fontWeight="600"
          letterSpacing="0.06em"
          textTransform="uppercase"
          color="grayDisabledText"
        >
          · {relativeFormat(inactiveAt)}
        </Text>
      </Flex>

      <Heading
        as="span"
        display="block"
        fontSize="28px"
        fontWeight="700"
        lineHeight="1.1"
        color="offerInactiveInk"
        textDecoration="line-through"
        mb="14px"
      >
        {formatMoney(amount)}
      </Heading>

      <Flex
        align="center"
        gap="10px"
        minW={0}
        bg="offerInactiveStripBG"
        borderWidth="1px"
        borderColor="gainsboro"
        borderRadius="8px"
        px="14px"
        py="10px"
      >
        <Icon as={stripIcon} boxSize="14px" color="grayMedium" flexShrink={0} />
        <Text fontSize="12px" color="grayLight" fontWeight="500">
          {stripCopy}
        </Text>
      </Flex>

      {showConversationEntry && (
        <ConversationDoorway thread={thread} history={card.history} onOpen={onOpenConversation} />
      )}
    </Box>
  );
};

export default InactiveOfferCard;
